import { FeatureFlags } from "flagged";

import { getObject, RepositoryKey } from "utils/repository";

export const FLAG_AUDIT_LOGS = "audit_logs";
export const FLAG_ASSET_MANAGEMENT = "asset_management";
export const FLAG_FILE_SHARING = "file_sharing";
export const FLAG_MANUAL_ENTITLEMENT_LIMITATION = "manual_entitlement_limitation";
export const FLAG_SCHEDULED_LICENSE_DELIVERY = "scheduled_license_delivery";
export const FLAG_WORKFLOW_EDITOR_V3 = "workflow_editor_v3";
export const FLAG_AI_ADDONS = "ai-addons";
export const FLAG_AI_HOME = "ai_home_page";
export const FLAG_BAM_PORTAL = "bam_portal";
export const FLAG_UICOMPS_USERS_TABLES = "uicomps_users_tables";
export const FLAG_UICOMPS_USER_GROUPS_TABLE = "uicomps_user_groups_table";
export const FLAG_UICOMPS_ROLES_TABLE = "uicomps_roles_table";
export const FLAG_REPORT_SIGNATURE_KEYS = "report_signature_keys";
export const FLAG_BAM_GRADING = "bam_grading";
export const FLAG_BAM_REPORTS = "bam_reports";
export const FLAG_BAM_INTEGRATIONS = "bam_integrations";
export const FLAG_BAM_ADDONS = "bam_addons";
export const FLAG_MOBILE_NAVIGATION = "mobile_navigation";
export const FLAG_RESTRUCTURED_NAVIGATION = "restructured_navigation";
export const FLAG_AI_ONBOARDING = "ai_onboarding";
export const FLAG_DEVICE_PASSPORT = "device_passport";
export const FLAG_AI_LICENSE_CONSUMPTION = "ai_license_consumption";

// In production there won't be any overriding values in LocalStorage so this
// constant alone defines the flags there.
export const DEFAULT_FLAGS: FeatureFlags = {
    [FLAG_MANUAL_ENTITLEMENT_LIMITATION]: false,
    [FLAG_SCHEDULED_LICENSE_DELIVERY]: true,
    [FLAG_WORKFLOW_EDITOR_V3]: true,
    [FLAG_ASSET_MANAGEMENT]: true,
    [FLAG_FILE_SHARING]: true,
    [FLAG_UICOMPS_USERS_TABLES]: true,
    [FLAG_UICOMPS_USER_GROUPS_TABLE]: true,
    [FLAG_UICOMPS_ROLES_TABLE]: true,
    [FLAG_AI_ADDONS]: false,
    [FLAG_AI_HOME]: true,
    [FLAG_AUDIT_LOGS]: true,
    [FLAG_BAM_PORTAL]: false,
    [FLAG_REPORT_SIGNATURE_KEYS]: true,
    [FLAG_BAM_GRADING]: true,
    [FLAG_BAM_REPORTS]: false,
    [FLAG_BAM_INTEGRATIONS]: true,
    [FLAG_BAM_ADDONS]: false,
    [FLAG_MOBILE_NAVIGATION]: false,
    [FLAG_RESTRUCTURED_NAVIGATION]: true,
    [FLAG_AI_ONBOARDING]: false,
    [FLAG_DEVICE_PASSPORT]: true,
    [FLAG_AI_LICENSE_CONSUMPTION]: false,
};

export type FeatureFlagKey = keyof typeof DEFAULT_FLAGS;

class FeatureFlagService {
    private flags: FeatureFlags;

    constructor() {
        this.flags = Object.assign({}, DEFAULT_FLAGS);
    }

    getFlags(): FeatureFlags {
        return this.flags;
    }

    // to use in non React components
    isFeatureEnabled(flag: FeatureFlagKey): boolean {
        const flags = this.flags;
        if (Array.isArray(flags)) {
            return false;
        }
        const value = flags[flag];
        return typeof value === "boolean" && value;
    }

    override(overriding: FeatureFlags): FeatureFlagService {
        this.flags = Object.assign({}, DEFAULT_FLAGS, overriding);
        return this;
    }
}

function readLocalStorageFlags(): FeatureFlags {
    return getObject<FeatureFlags>(RepositoryKey.FEATURE_FLAGS) ?? {};
}

export const featureFlagService = new FeatureFlagService().override(readLocalStorageFlags());
